import { ViewWrapper } from "../components/ViewWrapper";

export function TrainingView() {
  return (
    <ViewWrapper>
      <div
        style={{
          width: "100%",
          height: "100%",
          minHeight: "calc(100vh - 60px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="pulse-glow"
          style={{
            fontSize: 48,
            fontWeight: 300,
            letterSpacing: 4,
            color: "#fff",
            textAlign: "center",
            textTransform: "lowercase",
          }}
        >
          coming soon...
        </div>
      </div>
    </ViewWrapper>
  );
}
